import React from "react";
import mujerHome from "../../img/mujer_home.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

const Inicio = () => {
    return (
        <div className="flex flex-col justify-center w-full bg-[#ffffff]">
            <div className="flex justify-center">
                <div className="grid items-center grid-cols-1 gap-4 mt-20 md:grid-cols-[50%,50%] 3xl:w-2/3 2xl:w-3/4 lg:w-4/5 md:w-5/6 w-11/12 mx-auto">
                    <div className="mb-5">
                        <div className="w-full md:w-11/12">
                            <div className="flex items-center justify-center gap-1 ">
                                <div
                                    className=" font-bold text-center text-[#029DE0] 2xl:text-5xl lg:text-4xl md877:text-3xl text-2xl md:text-left "
                                    style={{ lineHeight: "1.3" }}
                                >
                                    Gestiona tus propiedades de forma
                                    inteligente y
                                    <p
                                        className="mx-1 inline font-bold text-center  text-[#071829] bg-[#C3EA43] rounded-lg px-2   md:text-left"
                                        style={{
                                            boxDecorationBreak: "clone",
                                            WebkitBoxDecorationBreak: "clone",
                                        }}
                                    >
                                        aumenta tu rentabilidad sin
                                        complicaciones
                                    </p>
                                </div>
                            </div>

                            <p className="md:w-5/6 w-full mx-auto mt-4 text-sm text-center 2xl:text-xl xl:text-lg md877:text-base md:text-left md:mx-0">
                                Ahorra tiempo, reduce costos y maximiza tus
                                ingresos con nuestra plataforma.
                            </p>

                            <div
                                onClick={() => {
                                    window.open(
                                        "https://calendar.app.google/7aKBqkaqESiPuTtE8"
                                    );
                                }}
                                className=" xl:text-base text-sm w-fit md:mx-0 mx-auto  flex justify-center items-center gap-2 rounded-lg text-white px-4 py-2 bg-gradient-to-r from-[#029DE0] to-[#44C7FF] mt-5 hover:scale-105 cursor-pointer "
                            >
                                Agenda tu demo
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 16 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M5.375 16.125C5.05859 16.125 4.77734 16.0195 4.56641 15.8086C4.10938 15.3867 4.10938 14.6484 4.56641 14.2266L10.5078 8.25L4.56641 2.30859C4.10938 1.88672 4.10938 1.14844 4.56641 0.726562C4.98828 0.269531 5.72656 0.269531 6.14844 0.726562L12.8984 7.47656C13.3555 7.89844 13.3555 8.63672 12.8984 9.05859L6.14844 15.8086C5.9375 16.0195 5.65625 16.125 5.375 16.125Z"
                                        fill="white"
                                    />
                                </svg>{" "}
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center justify-center w-full  ">
                        <img src={mujerHome} alt="mujer" />
                    </div>
                </div>
            </div>

            <div className="bg-[#029DE0] py-2 flex justify-start items-center gap-5 text-white text-lg w-full">
                <Swiper
                    className="w-full"
                    slidesPerView="auto"
                    spaceBetween={10}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false, // cambia esto si deseas otro intervalo
                    }}
                    loop
                    modules={[Autoplay]}
                >
                    <SwiperSlide className="!w-auto">
                        <div className="flex justify-center items-center gap-5 mx-10 cursor-pointer xl:text-base text-sm ">
                            <div>Gestiona tu propiedad con nosotros</div>
                            <div className="rounded-full py-1 px-5 bg-white bg-opacity-30 border border-white  ">
                                ¡Obtén tu prueba GRATIS por 15 días!
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide className="!w-auto">
                        <div className="flex justify-center items-center gap-5 mx-10 cursor-pointer xl:text-base text-sm">
                            <div>Gestiona tu propiedad con nosotros</div>
                            <div className="rounded-full py-1 px-5 bg-white bg-opacity-30 border border-white  ">
                                ¡Obtén tu prueba GRATIS por 15 días!
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide className="!w-auto">
                        <div className="flex justify-center items-center gap-5 mx-10 cursor-pointer xl:text-base text-sm">
                            <div>Gestiona tu propiedad con nosotros</div>
                            <div className="rounded-full py-1 px-5 bg-white bg-opacity-30 border border-white  ">
                                ¡Obtén tu prueba GRATIS por 15 días!
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </div>
    );
};
export default Inicio;
